import axios from "axios";

const buscarBodegasService = async () => {
    const token = localStorage.getItem("token");
    const config = {
        headers:{
            Authorization: token
        }
    };
    try {
        const respuesta = await axios.get(
            `${process.env.REACT_APP_API_URL}/bodegas`,
            config
        );
        return [true, respuesta.data, respuesta.status];
    } catch (error) {
        return [false, null, error.status];
    }
}

const guardarBodegasService = async (data) => {
    const token = localStorage.getItem("token");
    const config = {
        headers:{
            Authorization: token
        }
    };
    try {
        const respuesta = await axios.post(
            `${process.env.REACT_APP_API_URL}/bodegas`,
            data,
            config
        );
        return [true, respuesta.data, respuesta.status];
    } catch (error) {
        return [false, null, error.status];
    }
}

const editarBodegasService = async (id, data) => {
    const token = localStorage.getItem("token");
    const config = {
        headers:{
            Authorization: token
        }
    };
    try {
        const respuesta = await axios.put(
            `${process.env.REACT_APP_API_URL}/bodegas/${id}`,
            data,
            config
        );
        return [true, respuesta.data, respuesta.status];
    } catch (error) {
        return [false, null, error.status];
    }
}

const buscarBodegaPorPuntoVenta = async () => {
    const token = localStorage.getItem("token");
    const config = {
        headers:{
            Authorization: token
        }
    };
    try {
        const respuesta = await axios.get(
            `${process.env.REACT_APP_API_URL}/bodegas`,
            config
        );
        return [true, respuesta.data, respuesta.status];
    } catch (error) {
        return [false, null, error.status];
    }
}

export {
    buscarBodegasService,
    guardarBodegasService,
    editarBodegasService,
    buscarBodegaPorPuntoVenta
}